import { Asterisk } from "lucide-react";

const ITEMS = [
  "Je ne pouvais pas vendre de rêves",
  "Alors j’ai vendu des émotions",
  "Je ne pouvais pas vendre de rêves",
  "Alors j’ai vendu des émotions",
  "Je ne pouvais pas vendre de rêves",
  "Alors j’ai vendu des émotions",
];

export default function Marquee() {
  return (
    <div className="overflow-hidden border-y border-white/5 bg-coal py-5" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center" aria-hidden={half === 1}>
            {ITEMS.map((t, i) => (
              <span key={i} className="flex items-center">
                <span className="px-10 font-mono text-[11px] uppercase tracking-[0.35em] text-zinc-500">{t}</span>
                <Asterisk className="h-3.5 w-3.5 text-ember" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
